// WageRateNoticeFieldMappings.js
import { PDFDocument, rgb } from 'pdf-lib';

export const getFormattedDate = () => {
  const today = new Date();
  return `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
};

export const WageRateNoticeFieldMappings = {
    // Employer Information Section (Section 1)
    employerInfo: {
      employerName: {
        type: 'text',
        page: 0,
        x: 64,
        y: 450,
        maxWidth: 300,
        fontSize: 11
      },
      name: {
        type: 'text',
        page: 0,
        x: 64,
        y: 450,
        maxWidth: 300,
        fontSize: 11
      },
      dbaNames: {
        type: 'text',
        page: 0,
        x: 64,
        y: 400,
        maxWidth: 300,
        fontSize: 11
      },
      fein: {
        type: 'text',
        page: 0,
        x: 64,
        y: 360,
        maxWidth: 150,
        fontSize: 11
      },
      physicalAddress: {
        type: 'text',
        page: 0,
        x: 64,
        y: 320,
        maxWidth: 150,
        fontSize: 11
      },
      mailingAddress: {
        type: 'text',
        page: 0,
        x: 64,
        y: 260,
        maxWidth: 150,
        fontSize: 11
      },
      phone: {
        type: 'text',
        page: 0,
        x: 64,
        y: 210,  // Adjusted for phone. Done
        maxWidth: 150,
        fontSize: 11
      }
    },
  
    // Notice Type Section (Section 2)
    noticeType: {
      hiring: {
        type: 'checkbox',
        page: 0,
        x: 50,
        y: 165,  // Adjusted for hiring checkbox. Done
        size: 12
      },
      change: {
        type: 'checkbox',
        page: 0,
        x: 50,
        y: 155,  // Adjusted for change checkbox. Done
        size: 12
      }
    },
  
    // Employee's Rate of Pay (Section 3)
    payInfo: {
      hourlyRate: {
        type: 'text',
        page: 0,
        x: 330,
        y: 490,  // Adjusted for hourly rate. Done. 
        maxWidth: 80,
        fontSize: 11
      },
      overtimeRate: {
        type: 'text',
        page: 0,
        x: 305,
        y: 245,  // Overtime rate position looks correct. Done
        maxWidth: 80,
        fontSize: 11
      }
    },
  
    // Allowances Section (Section 4)
    allowances: {
      none: {
        type: 'checkbox',
        page: 0,
        x: 302,
        y: 445,  // Adjusted for allowances section
        size: 12
      },
      tips: {
        type: 'checkbox',
        page: 0,
        x: 302,
        y: 435,
        size: 12
      },
      meals: {
        type: 'checkbox',
        page: 0,
        x: 302,
        y: 415,
        size: 12
      },
      lodging: {
        type: 'checkbox',
        page: 0,
        x: 302,
        y: 395,
        size: 12
      },
      other: {
        type: 'checkbox',
        page: 0,
        x: 302,
        y: 380,
        size: 12
      }
    },
  
    // Allowance Amounts
    allowanceAmounts: {
      tips: {
        type: 'text',
        page: 0,
        x: 275,
        y: 335,
        maxWidth: 80,
        fontSize: 11
      },
      meals: {
        type: 'text',
        page: 0,
        x: 275,
        y: 315,
        maxWidth: 80,
        fontSize: 11
      },
      lodging: {
        type: 'text',
        page: 0,
        x: 275,
        y: 295,
        maxWidth: 80,
        fontSize: 11
      },
      other: {
        type: 'text',
        page: 0,
        x: 275,
        y: 275,
        maxWidth: 150,
        fontSize: 11
      }
    },
  
    // Pay Schedule (Section 5 & 6)
    regularPayday: {
      type: 'text',
      page: 0,
      x: 400,
      y: 365,  // Regular payday looks correct
      maxWidth: 150,
      fontSize: 11
    },
  
    payFrequency: {
      weekly: {
        type: 'checkbox',
        page: 0,
        x: 305,
        y: 315,  // Weekly checkbox looks correct
        size: 12
      }
    },
  
    // Employee Acknowledgement (Section 8)
    language: {
      english: {
        type: 'checkbox',
        page: 0,
        x: 543,
        y: 415,
        size: 12
      },
      other: {
        type: 'checkbox',
        page: 0,
        x: 540,
        y: 385,
        size: 12
      },
      otherLanguage: {
        type: 'text',
        page: 0,
        x: 690,
        y: 385,
        maxWidth: 150,
        fontSize: 11
      }
    },
  
    employeeName: {
      type: 'text',
      page: 0,
      x: 550,
      y: 310,  // Employee name looks correct
      maxWidth: 300,
      fontSize: 11
    },
  
    signature: {
      type: 'image',
      page: 0,
      x: 550,
      y: 270,  // Signature position looks correct
      width: 200,
      height: 20
    },
  
    signatureDate: {
      type: 'text',
      page: 0,
      x: 550,
      y: 235,  // Date field looks correct
      maxWidth: 100,
      fontSize: 8
    },
  
    preparerName: {
      type: 'text',
      page: 0,
      x: 550,
      y: 200,  // Preparer name looks correct
      maxWidth: 300,
      fontSize: 11
    }
  };
// Helper function to draw debug elements
const drawDebugMarker = (page, x, y, label, type) => {
    // Draw coordinate cross
    page.drawLine({
      start: { x: x - 5, y },
      end: { x: x + 5, y },
      color: rgb(1, 0, 0),
      thickness: 0.5
    });
    page.drawLine({
      start: { x, y: y - 5 },
      end: { x, y: y + 5 },
      color: rgb(1, 0, 0),
      thickness: 0.5
    });
  
    // Draw label with coordinates and type
    page.drawText(`${label} (${x},${y}) [${type}]`, {
      x: x + 10,
      y: y + 2,
      size: 6,
      color: rgb(0, 0, 1)
    });
  };
  export const fillPDFForm = async (pdfDoc, formData, signatureImage, debug = false) => {
    const pages = pdfDoc.getPages();
    const page = pages[0];
    
    // Draw debug grid if debugging is enabled
    if (debug) {
      // Draw vertical grid lines
      for (let x = 0; x <= 1000; x += 50) {
        page.drawLine({
          start: { x, y: 0 },
          end: { x, y: 1000 },
          color: rgb(0.9, 0.9, 0.9),
          thickness: 0.5
        });
        page.drawText(`${x}`, {
          x: x + 2,
          y: 10,
          size: 6,
          color: rgb(0.5, 0.5, 0.5)
        });
      }
  
      // Draw horizontal grid lines
      for (let y = 0; y <= 1000; y += 50) {
        page.drawLine({
          start: { x: 0, y },
          end: { x: 1000, y },
          color: rgb(0.9, 0.9, 0.9),
          thickness: 0.5
        });
        page.drawText(`${y}`, {
          x: 2,
          y: y + 2,
          size: 6,
          color: rgb(0.5, 0.5, 0.5)
        });
      }
    }
  
    const drawText = (text, mapping) => {
      if (mapping.type === 'multiline') {
        // Split text into words
        const words = text.toString().split(' ');
        let lines = [];
        let currentLine = '';
  
        // Build lines that fit within maxWidth
        words.forEach(word => {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          const testWidth = testLine.length * (mapping.fontSize / 2); // Rough estimate of width
          
          if (testWidth < mapping.maxWidth) {
            currentLine = testLine;
          } else {
            lines.push(currentLine);
            currentLine = word;
          }
        });
        if (currentLine) {
          lines.push(currentLine);
        }
  
        // Draw each line with proper spacing
        lines.forEach((line, index) => {
          page.drawText(line.trim(), {
            x: mapping.x,
            y: mapping.y - (index * mapping.lineHeight),
            size: mapping.fontSize
          });
        });
      } else {
        // Regular single-line text
        page.drawText(text.toString(), {
          x: mapping.x,
          y: mapping.y,
          size: mapping.fontSize,
          maxWidth: mapping.maxWidth
        });
      }
    };
  
    // Fill employer information
    Object.entries(formData).forEach(([field, value]) => {
      const mapping = WageRateNoticeFieldMappings.employerInfo[field];
      if (mapping && value) {
        if (debug) {
          drawDebugMarker(page, mapping.x, mapping.y, `employer.${field}`, mapping.type);
        }
        drawText(value, mapping);
      }
    });
  
    // Fill notice type
    const noticeTypeMapping = WageRateNoticeFieldMappings.noticeType[formData.noticeType];
    if (noticeTypeMapping) {
      if (debug) {
        drawDebugMarker(page, noticeTypeMapping.x, noticeTypeMapping.y, 'noticeType', 'checkbox');
      }
      page.drawText('X', {
        x: noticeTypeMapping.x,
        y: noticeTypeMapping.y,
        size: noticeTypeMapping.size
      });
    }
  
    // Fill pay info
    if (formData.employeeHourlyRate) {
      const rateMapping = WageRateNoticeFieldMappings.payInfo.hourlyRate;
      if (debug) {
        drawDebugMarker(page, rateMapping.x, rateMapping.y, 'hourlyRate', 'text');
      }
      drawText(formData.employeeHourlyRate, rateMapping);
    }
  
    // Fill overtime rate
    if (formData.overtimeRate) {
      const overtimeMapping = WageRateNoticeFieldMappings.payInfo.overtimeRate;
      if (debug) {
        drawDebugMarker(page, overtimeMapping.x, overtimeMapping.y, 'overtimeRate', 'text');
      }
      drawText(formData.overtimeRate, overtimeMapping);
    }
  
    // Fill allowances
    Object.entries(formData.allowances).forEach(([allowance, isChecked]) => {
      if (isChecked && WageRateNoticeFieldMappings.allowances[allowance]) {
        const mapping = WageRateNoticeFieldMappings.allowances[allowance];
        if (debug) {
          drawDebugMarker(page, mapping.x, mapping.y, `allowance.${allowance}`, 'checkbox');
        }
        page.drawText('X', {
          x: mapping.x,
          y: mapping.y,
          size: mapping.size
        });
  
        if (formData.allowanceAmounts[allowance] && WageRateNoticeFieldMappings.allowanceAmounts[allowance]) {
          const amountMapping = WageRateNoticeFieldMappings.allowanceAmounts[allowance];
          if (debug) {
            drawDebugMarker(page, amountMapping.x, amountMapping.y, `allowanceAmount.${allowance}`, 'text');
          }
          drawText(formData.allowanceAmounts[allowance], amountMapping);
        }
      }
    });
  
    // Fill regular payday
    const regularPaydayMapping = WageRateNoticeFieldMappings.regularPayday;
    if (debug) {
      drawDebugMarker(page, regularPaydayMapping.x, regularPaydayMapping.y, 'regularPayday', 'text');
    }
    drawText('Friday', regularPaydayMapping);
  
    // Fill pay frequency
    const weeklyMapping = WageRateNoticeFieldMappings.payFrequency.weekly;
    if (debug) {
      drawDebugMarker(page, weeklyMapping.x, weeklyMapping.y, 'payFrequency.weekly', 'checkbox');
    }
    page.drawText('X', {
      x: weeklyMapping.x,
      y: weeklyMapping.y,
      size: weeklyMapping.size
    });
  
    // Fill language selection
    const languageMapping = WageRateNoticeFieldMappings.language[formData.primaryLanguage];
    if (languageMapping) {
      if (debug) {
        drawDebugMarker(page, languageMapping.x, languageMapping.y, `language.${formData.primaryLanguage}`, 'checkbox');
      }
      page.drawText('X', {
        x: languageMapping.x,
        y: languageMapping.y,
        size: languageMapping.size
      });
  
      if (formData.primaryLanguage === 'other' && formData.otherLanguage) {
        const otherLangMapping = WageRateNoticeFieldMappings.language.otherLanguage;
        if (debug) {
          drawDebugMarker(page, otherLangMapping.x, otherLangMapping.y, 'language.other', 'text');
        }
        drawText(formData.otherLanguage, otherLangMapping);
      }
    }
  
    // Fill employee name
    if (formData.employeeName) {
      const nameMapping = WageRateNoticeFieldMappings.employeeName;
      if (debug) {
        drawDebugMarker(page, nameMapping.x, nameMapping.y, 'employeeName', 'text');
      }
      drawText(formData.employeeName, nameMapping);
    }
  
    // Add signature
    if (signatureImage) {
      const signatureMapping = WageRateNoticeFieldMappings.signature;
      if (debug) {
        drawDebugMarker(page, signatureMapping.x, signatureMapping.y, 'signature', 'image');
      }
      const img = await pdfDoc.embedPng(signatureImage);
      page.drawImage(img, {
        x: signatureMapping.x,
        y: signatureMapping.y,
        width: signatureMapping.width,
        height: signatureMapping.height
      });
    }
  
    // Add date
    const dateMapping = WageRateNoticeFieldMappings.signatureDate;
    if (debug) {
      drawDebugMarker(page, dateMapping.x, dateMapping.y, 'signatureDate', 'text');
    }
    drawText(formData.signatureDate || getFormattedDate(), dateMapping);
  
    // Add preparer name
    const preparerMapping = WageRateNoticeFieldMappings.preparerName;
    if (debug) {
      drawDebugMarker(page, preparerMapping.x, preparerMapping.y, 'preparerName', 'text');
    }
    drawText(formData.employerName || '', preparerMapping);
  
    return pdfDoc;
  };